module.exports = __webpack_public_path__ + "static/fundamentals-software-36def47efbf4a2396220efd09cee3173.jpg";